import { ConductConnotation } from '@schooly/api';

export const separateTypesByConnotation = <T extends { connotation: ConductConnotation }>(
  types: T[],
) => ({
  positiveConductTypes: types.filter((t) => t.connotation === ConductConnotation.POSITIVE),
  negativeConductTypes: types.filter((t) => t.connotation === ConductConnotation.NEGATIVE),
});
